import {FEATURE_NAMES} from '../growthbook/constants';

import {handleGrowthBookUpdateEvent} from './helpers/growthbook';

const FEATURE_DEFAULT_VALUE = 'group_a';
const FEATURE_ENABLED_VALUE = 'group_b';
const MAX_REPLACE_SYMBOLS = 700;

function getInsertRefElement (elementList) {
  let totalSymbols = 0;

  return elementList.find(element => {
    totalSymbols = totalSymbols + element.innerText.length;
    return totalSymbols > MAX_REPLACE_SYMBOLS;
  }) || elementList[elementList.length - 1];
}

const renderLatestInTrend = articleId => {
  const articleElement = document
    .querySelector(`.layout-content-type-page__content .js-article[data-id="${articleId}"]`);

  if (!articleElement) {
    return;
  }

  const latestInTrendElement = articleElement.querySelector('.latest-in-trend');

  if (!latestInTrendElement) {
    return;
  }

  if (window.growthBook?.getFeatureValue(FEATURE_NAMES.ARTICLE_LATEST_IN_TREND) !== FEATURE_ENABLED_VALUE) {
    return;
  }

  const paragraphElementList = Array
    .from(articleElement.querySelectorAll('.formatted-body__content--wrapper > p'))
    .filter(paragraph => paragraph.innerText.length > 0)
    .slice(1);

  const growthBookValue = window.growthBook?.getFeatureValue(FEATURE_NAMES.ARTICLE_LATEST_IN_TREND);

  if (growthBookValue === FEATURE_DEFAULT_VALUE) {
    const insertRefElement = paragraphElementList[0];

    if (!insertRefElement || !insertRefElement.parentNode) {
      return;
    }

    insertRefElement.parentNode.insertBefore(latestInTrendElement, insertRefElement);
    return;
  }

  if (growthBookValue === FEATURE_ENABLED_VALUE) {
    const insertRefElement = getInsertRefElement(paragraphElementList);

    if (!insertRefElement || !insertRefElement.parentNode) {
      return;
    }

    insertRefElement.parentNode.insertBefore(latestInTrendElement, insertRefElement.nextSibling);
  }
};

const initLatestInTrendAB = articleId => {
  renderLatestInTrend(articleId);

  handleGrowthBookUpdateEvent(() => {
    renderLatestInTrend(articleId);
  });
};

export {initLatestInTrendAB};
